module.exports = __webpack_public_path__ + "static/media/clearCheckbox.a669ff41.svg";